export const ONE = '1';
export const X = 'x';
export const TWO = '2';
